// extracted by mini-css-extract-plugin
export default {"link":"navigateLink_link__nGRoB","activeLink":"navigateLink_activeLink__3BTrV"};